<template>
  <LandingTemplate>
    <form id="login-form" class="login-form m-auto" @submit.prevent @keydown.enter.prevent>
      <div class="login-form__header">
        <img src="@/assets/svg/images/enter.svg" alt="">
        <h2 class="text-black fw-500 my-20">Вхід</h2>
      </div>
      <button
        class="id-gov-ua fs-14 fw-500"
        @click="getSignToken"
        @keydown.enter.prevent
      >
        Увійти за допомогою КЕП
      </button>
      <div class="text-black-neutrals agreement-block fs-14" @click="setProcessing">
        <input
          id="agree"
          type="checkbox"
          name="agree"
          class="mc-checkbox"
          :checked="processingAgreed"
          @click.stop="setProcessing"
        >
        <span class="mx-auto">Я згоден на обробку персональних даних</span>
      </div>
      <p class="text-grey sub-text fs-12">або</p>
      <mc-input
        name="email"
        type="email"
        :class="{'error': fieldErrors.email}"
        placeholder="Email"
        autocomplete="email"
        :model-value="email"
        v-model:model-value="email"
        @update:model-value="updateValue($event, 'email')"
      />
      <app-password-input
        name="password"
        placeholder="Пароль"
        :error="fieldErrors.password"
        :model-value="password"
        @update:model-value="updateValue($event, 'password')"
      />
      <button class="btn-black fs-14 fw-500" @click="loginEmail">
        Увійти
      </button>
      <router-link class="forgot-password fs-14 fw-500" :to="{name: routerNames.AUTH.resetPassword}">
        Забули пароль?
      </router-link>
    </form>
    <SignDialog
      v-if="$store.state.ready"
      title="Увійти за допомогою ЕЦП"
      :data="signToken"
      v-model:active="showSignModal"
      @sign="signAuth($event)"
    />
  </LandingTemplate>
</template>

<script>
import api from '@/api';
import {NOTIFICATIONS} from '@/utils/constants';
import routerNames from '@/router/routerNames';
import LandingTemplate from '@/views/Landing/LandingTemplate';
import McInput from '@/components/forms/McInput';
import SignDialog from '@/components/modal/EuSign/SignDialog';
import AppPasswordInput from '@/components/forms/Inputs/AppPasswordInput';

export default {
  name: 'LoginView',
  components: {
    AppPasswordInput,
    McInput,
    LandingTemplate,
    SignDialog
  },
  async mounted() {
    if (this.$route.query?.message === 'login') {
      this.$store.commit('setNotification', NOTIFICATIONS.landing.auth);
      await this.$router.push({name: routerNames.AUTH.login});
    }
  },
  data() {
    return {
      signToken: '',
      showSignModal: false,
      email: '',
      password: '',
      processingAgreed: false,
      processingError: false,
      fieldErrors: {
        email: false,
        password: false
      },
    };
  },
  computed: {
    routerNames() {
      return routerNames;
    }
  },
  methods: {
    updateValue(event, input) {
      this[input] = event;
      if (this.fieldErrors[input]) {
        this.fieldErrors[input] = false;
      }
    },
    setProcessing() {
      this.processingAgreed = !this.processingAgreed;
      if (this.processingError) {
        this.$store.commit('setNotification', {text: '', type: '', svg: ''});
      }
    },
    checkForm() {
      if (!this.email || !this.password) {
        Object.keys(this.fieldErrors).forEach(
          (el) => this.fieldErrors[el] = !this[el]
        );
        this.$store.commit('setNotification', NOTIFICATIONS.landing.nonFields);
        return false;
      }
      return true;
    },

    async loginEmail() {
      const checkForm = this.checkForm();
      if (!checkForm) {
        return;
      }
      await api.auth.csrfToken();
      const success = await this.$store.dispatch('logIn', {email: this.email, password: this.password});
      if (!success) {
        Object.keys(this.fieldErrors).forEach(
          (el) => this.fieldErrors[el] = true
        );
        this.$store.commit('setNotification', NOTIFICATIONS.landing.apiError);
        return ;
      }
      await this.goNext();

    },
    async getSignToken() {
      if (!this.processingAgreed) {
        this.processingError = !this.processingError ? !this.processingError : this.processingError;
        this.$store.commit('setNotification', NOTIFICATIONS.landing.processing);
        return;
      }
      await api.auth.csrfToken();
      const [response, error] = await api.auth.getSignToken();
      if (error && error.status === 403) {
        this.$store.commit('setNotification', NOTIFICATIONS.landing.signToken);
        this.$store.commit('setUser', {});
        await api.auth.logout();
        return;
      }
      this.signToken = response.data['sign-token'];
      this.showSignModal = true;
    },
    /**
     * @param {string} sign
     */
    async signAuth(sign) {
      await api.auth.csrfToken();
      const [response, error] = await api.auth.login(sign);
      if (error) {
        this.$store.commit('setNotification', NOTIFICATIONS.landing.apiError);
        return;
      }
      this.$store.commit('setUser', response.data.user);
      this.$store.commit('setReady', false);
      await this.goNext();
    },
    async goNext() {
      const name = this.$store.getters.isActiveUser
        ? routerNames.AUTH.root
        : routerNames.ORGANIZATIONS.my;
      const route = this.$router.resolve({name: name});
      window.open(route.href, '_self');
    }
  }
};
</script>
